// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"2":"6bc3673f","394":"2e27bd48","634":"af0dad98","813":"c0ff5500","825":"85aa1f7b"}[chunkId] + ".chunk.js");